import React from "react";
import Input from "../Builder/nodes/Logic/Inputs/Input";

export default function EventTableFilter({ filters, setFilters }) {
  return (
    <div className="d-flex justify-content-between bg-colored-reverse bg-accross rounded-3 p-3 gap-3 align-items-center my-3 m-0">
      <div className="col-4">
        <label className="fw-bold text-white p-2">Filter by event status:</label>
        <Input
          inputType="select"
          isMulti
          value={filters.status || []}
          onChange={(v) => setFilters({ ...filters, status: v })}
          options={[
            { value: "creating", label: "Creating" },
            { value: "active", label: "Active" },
            { value: "resolved", label: "Resolved" },
            { value: "closed", label: "Closed" },
            { value: "archived", label: "Archived" },
          ]}
        />
      </div>
      <div className="col-4">
        <label className="fw-bold text-white p-2">Filter by event severity:</label>
        <Input
          inputType="select"
          isMulti
          value={filters.severity || []}
          onChange={(v) => setFilters({ ...filters, severity: v })}
          options={[
            { value: "low", label: "Low" },
            { value: "medium", label: "Medium" },
            { value: "high", label: "High" },
            { value: "critical", label: "Critical" },
          ]}
        />
      </div>
    </div>
  );
}
